import * as React from 'react';
import { cn } from '@wayste/shadcn/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps, cva } from 'class-variance-authority';

const badgeVariants = cva(
    'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-border-focus focus-visible:ring-border-focus/50 focus-visible:ring aria-invalid:ring-destructive-default/20 dark:aria-invalid:ring-destructive-default/40 aria-invalid:border-destructive-default transition-[color,box-shadow] overflow-hidden',
    {
        variants: {
            variant: {
                default: 'border-transparent bg-primary-default text-primary-on-default-text [a&]:hover:bg-primary-hover',
                secondary: 'border-transparent bg-secondary-default text-text-secondary [a&]:hover:bg-secondary-hover',
                destructive:
                    'border-transparent bg-destructive-default text-destructive-on-default-text [a&]:hover:bg-destructive-hover focus-visible:ring-destructive-default/20 dark:focus-visible:ring-destructive-default/40 dark:bg-destructive-default/60',
                outline: 'text-text-primary [a&]:hover:bg-surface-secondary [a&]:hover:text-text-primary',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

function Badge({
    className,
    variant,
    asChild = false,
    ...props
}: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
    const Comp = asChild ? Slot : 'span';

    return <Comp data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
